import axios from './configAxios';

export const postEntryReportsApi = async (requestData) => {
	return await axios.post('/create/', requestData);
};
